import {
  chakra,
  ComponentWithAs,
  forwardRef,
  HTMLChakraProps,
  useStyleConfig,
} from '@chakra-ui/react';

import SunshineIcon, { IconName } from '../SunshineIcon';

export interface ChipProps extends HTMLChakraProps<'button'> {
  isActive?: boolean;
  isDisabled?: boolean;
  icon?: IconName;
  iconRight?: IconName;
}

const Chip: ComponentWithAs<'div', ChipProps> = forwardRef(
  ({ children, icon, iconRight, isActive, isDisabled, ...props }, ref) => {
    const styles = useStyleConfig('Chip', {
      icon,
      iconRight,
      isActive,
      variant: isActive ? 'active' : 'default',
    });

    return (
      <chakra.button __css={styles} disabled={isDisabled} ref={ref} {...props}>
        {icon ? (
          <chakra.svg as={SunshineIcon} name={icon} size="icon-20" />
        ) : null}

        <chakra.span flex={1}>{children}</chakra.span>

        {iconRight ? (
          <chakra.svg as={SunshineIcon} name={iconRight} size="icon-20" />
        ) : null}
      </chakra.button>
    );
  },
);

export default Chip;
